// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3ZFsp","alertIcon":"ConfirmModal_alertIcon__3r-iC"};